export enum NAVIGATION_LIST_ITEM_STATE {
  DEFAULT = 'default',
  ACTIVE = 'active',
}
export enum NAVIGATION_LIST_ITEM_DEPTH {
  DEFAULT = 'default',
  NESTED = 'nested',
}
export enum NAVIGATION_LIST_LABEL_LEVEL {
  SECTION = 'section',
  SUBSECTION = 'subsection',
}
export enum NAVIGATION_LIST_ROOT_AS {
  NAV = 'nav',
  DIV = 'div',
}
